import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=18d894ad&scoped=true&"
import script from "./my-pagination.vue?vue&type=script&lang=js&"
export * from "./my-pagination.vue?vue&type=script&lang=js&"
import style0 from "./my-pagination.vue?vue&type=style&index=0&id=18d894ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d894ad",
  null
  
)

export default component.exports